import { type Database } from "@fitness-app/supabase";

export type AgentSkill = Database["public"]["Tables"]["agent_skill"]["Row"];
export type AgentSkillInsert = Database["public"]["Tables"]["agent_skill"]["Insert"];
export type AgentSkillUpdate = Database["public"]["Tables"]["agent_skill"]["Update"];

/**
 * TRE-1613 — agent_skill rows are scoped by `kind`: `skill` rows are behavioural
 * prompt sections (ordered), `knowledge` rows are reference facts the agent may lean
 * on. Every read that builds a prompt must filter by kind — a knowledge entry read as
 * a skill would be injected as an instruction.
 */
export enum AgentSkillKind {
  Skill = "skill",
  Knowledge = "knowledge",
}
